import React, { useState, useEffect } from 'react';
import api from '../../services/api';

const STATUS_COLORS = {
  collected: '#f59e0b', received_origin: '#3b82f6', sorted: '#8b5cf6',
  received_destination: '#0891b2', ready_for_pickup: '#16a34a',
};

export default function Inbox() {
  const user = JSON.parse(localStorage.getItem('sdx_user') || '{}');
  const [hubId, setHubId] = useState(user.hub_id || 1);
  const [hubs, setHubs] = useState([]);
  const [rows, setRows] = useState([]);
  const load = async (id) => {
    try {
      const res = await api.get(`/parcels/hub/${id}/inbox`);
      setRows(res.data);
    } catch (_) { setRows([]); }
  };
  useEffect(() => {
    api.get('/hubs').then(r => setHubs(r.data));
  }, []);
  useEffect(() => { load(hubId); }, [hubId]);

  const byStatus = rows.reduce((acc, r) => { (acc[r.status] = acc[r.status] || []).push(r); return acc; }, {});

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <h1 style={{ margin: 0 }}>Hub Inbox</h1>
        <select className="input" style={{ width: 240, marginBottom: 0 }} value={hubId} onChange={e => setHubId(Number(e.target.value))}>
          {hubs.map(h => <option key={h.id} value={h.id}>{h.name} ({h.city})</option>)}
        </select>
      </div>
      {Object.keys(byStatus).length === 0 && <div className="card">Inbox empty. Nothing needs your attention right now.</div>}
      {Object.entries(byStatus).map(([status, list]) => (
        <div key={status} className="card">
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12 }}>
            <span style={{ background: STATUS_COLORS[status] || '#6b7280', color: '#fff', padding: '3px 10px', borderRadius: 6, fontSize: 12, fontWeight: 700, textTransform: 'uppercase' }}>
              {status.replace(/_/g, ' ')}
            </span>
            <span style={{ color: '#6b7280', fontSize: 13 }}>{list.length} parcels</span>
          </div>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
            <thead>
              <tr style={{ textAlign: 'left', color: '#6b7280', fontSize: 11, textTransform: 'uppercase' }}>
                <th style={{ padding: '6px 0' }}>Tracking</th>
                <th>From → To</th>
                <th>Sender</th>
                <th>Receiver</th>
                <th>Delivery</th>
              </tr>
            </thead>
            <tbody>
              {list.map(p => (
                <tr key={p.id} style={{ borderTop: '1px solid #f3f4f6' }}>
                  <td style={{ padding: '8px 0', fontWeight: 600 }}>{p.tracking_number}</td>
                  <td>{p.origin_hub_name} → {p.destination_hub_name}</td>
                  <td>{p.sender_name}</td>
                  <td>{p.receiver_name}</td>
                  <td>{p.delivery_option === 'hub_pickup' ? '🏪 Hub' : '🏠 Home'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ))}
    </div>
  );
}
